/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/base-theme
 */
export const CONFIGURABLE = 'configurable';
export const GROUPED = 'grouped';
export const SIMPLE = 'simple';
export const BUNDLE = 'bundle';
export const GIFT_CARD = 'amgiftcard';
export const DOWNLOADABLE = 'downloadable';
export const VIRTUAL = 'virtual';
export const RECENTLY_VIEWED_PRODUCTS_LIMIT = 10;
